



































const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";


@Component({
  components: {
  }
})

export default class AfterLoadCsvModal extends Vue 
{
    private isVisible = false;
    private completion : ((result : string) => void) | null = null;

    // 結果は
    // "ok", "cancel"
    public open(completion : (result : string) => void)
    {
        this.isVisible = true;
        this.completion = completion;

        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    private onOk()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
        
        this.isVisible = false;
        if(this.completion != null) { this.completion("ok"); }
    }

    private onCancel()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
        
        this.isVisible = false;
        if(this.completion != null) { this.completion("cancel"); }
    }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }
}
